import { connect } from 'react-redux';
import queryString from 'query-string';
import LandingPage from '../components/landing-page/LandingPage';

const mapStateToProps = (state, ownProps) => {
  const params = queryString.parse(ownProps.location.search);
  let splash, overlay;

  if (params.splash !== undefined) {
    splash = params.splash;
  }
  if (params.overlay !== undefined) {
    overlay = params.overlay;
  }

  let showOldMemberModal = false;
  if (state.selectedMemberId && 
      'currentMember' in state.memberList[state.selectedMemberId] && 
      state.memberList[state.selectedMemberId].currentMember === false) {
    showOldMemberModal = true;
  }
  
  return {
    memberList: state.memberList.filter(member => (member.personId !== undefined && member.fullName !== undefined)),
    splash: splash,
    overlay: overlay,
    showOldMemberModal: showOldMemberModal
  };
};

const ConnectedLandingPage = connect(mapStateToProps)(LandingPage);

export default ConnectedLandingPage;